import goTrackerConfig from 'goTrackerConfig';
import * as signalR from '@aspnet/signalr';
import _difference from 'lodash/difference'; //eslint-disable-line

const hubConnection = options => {
  const defaultOptions = {
    transport: ['webSockets', 'serverSentEvents', 'longPolling'],
    hubName: 'notifications',
    host: goTrackerConfig.signalrHost,
    retryInterval: 5000,
    onConnected: () => {},
    onDisconnected: () => {},
    callbacks: {},
  };
  const _options = Object.assign({}, defaultOptions, options);
  return new Promise(resolve => {
    if (!_options.host || _options.host.length < 1) {
      console.info('Signalr is not being used');
      return;
    }

    /*Trace = 0, Debug = 1, Information = 2, Warning = 3, Error = 4, Critical = 5, None = 6 -->  https://docs.microsoft.com/en-us/javascript/api/@aspnet/signalr/loglevel?view=signalr-js-latest*/
    let signalRLogLevel = goTrackerConfig.signalrLogLevel;
    if (signalRLogLevel === undefined) {
      signalRLogLevel = 3;
    }

    const conn = new signalR.HubConnectionBuilder()
      .withUrl(`${_options.host}${_options.hubName}`)
      .configureLogging(signalRLogLevel)
      .build();
    conn.on('RailOccupancy.Coach.Update', result => {
      console.log('RailOccupancy.Coach.Update', result);
      options.locationStore.updateFromSignalr();
    });

    const startConnection = () => {
      conn
        .start()
        .then(() => {
          console.log('%c --- SIGNALR is now Connected! --- ', 'background: #222; color: #bada55');
          _options.onConnected();
          resolve();
        })
        .catch(err => {
          console.error(err);
          _options.onDisconnected();
          setTimeout(startConnection, _options.retryInterval);
        });
    };

    conn.onclose(() => {
      console.warn('Signalr connection is closed');
      _options.onDisconnected();
      setTimeout(startConnection, _options.retryInterval);
    });

    global.signalRConnection = conn;
    startConnection();
  });
};

export default hubConnection;
